<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Infinity" class="d-icon d-icon--infinity" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M1.032 4.322c.376-.492.95-.822 1.687-.822 1.434 0 2.451.896 3.28 1.766.346-.37.715-.74 1.113-1.04.552-.416 1.197-.726 1.977-.726.781 0 1.4.313 1.815.802.406.479.596 1.1.596 1.7 0 .6-.191 1.22-.598 1.698-.415.488-1.033.8-1.813.8s-1.425-.31-1.977-.726c-.398-.3-.767-.67-1.113-1.04-.829.87-1.846 1.766-3.28 1.766-.737 0-1.31-.33-1.686-.82C.668 7.202.5 6.59.5 6.002c0-.588.167-1.201.532-1.68ZM5.315 6C4.493 5.136 3.74 4.5 2.72 4.5c-.409 0-.695.17-.892.43-.208.271-.327.66-.327 1.072 0 .411.12.798.328 1.07.197.258.483.428.891.428 1.02 0 1.774-.636 2.596-1.5Zm1.366 0c.35.375.682.711 1.033.976.443.334.88.524 1.375.524.493 0 .83-.188 1.052-.448.23-.272.358-.651.359-1.05 0-.4-.128-.78-.358-1.053-.222-.261-.56-.449-1.053-.449-.494 0-.932.19-1.375.524-.351.265-.682.6-1.033.976Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconInfinity',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
